<template>
    <va-edit-layout>
        <LoanServicingEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></LoanServicingEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
